import {
  LandingPageEnum,
  ThemeEnum,
  type UserPreferences,
} from '../interfaces/user.interface';

export const userPreferencesInitialState: UserPreferences = {
  theme: ThemeEnum.LIGHT,
  landingPage: LandingPageEnum.FEED,
};
